import Vue from "vue";
import * as types from "./mutation-types";

const actions = {
  teamShow(_, payload) {
    const { teamId, withMembers = 0 } = payload;

    const params = {
      teamId,
      withMembers
    };

    return Vue.axios.get(`teams/${teamId}`, { params }).then(response => {
      return response.data.data;
    });
  },

  async createTeam({ commit, dispatch, rootState }, formData) {
    // TODO refactor to use teamStagedMembers
    const recipientIds = rootState.challengeBuilder.stagedMembers.map(
      member => member.id
    );
    const teamMembersInviteMode = rootState.teams.teamMembersInviteMode;
    formData.set("programId", Vue.auth.user().programId);
    formData.set("addCreatorToTeam", rootState.teams.addCreatorToTeam ? 1 : 0);

    try {
      let response = await Vue.axios.post(`teams`, formData);
      if (response && response.data.success) {
        const team = response.data.data;
        if (recipientIds.length) {
          if (teamMembersInviteMode === "invite") {
            dispatch(
              "invites/inviteTeamMembers",
              { teamId: team.id, recipientIds },
              { root: true }
            );
          }
          if (teamMembersInviteMode === "add") {
            await dispatch(
              "teams/addMembersToTeam",
              { team: team, memberIds: recipientIds },
              { root: true }
            );
          }
        }

        // team creator auto joins
        // TODO admin will not auto join
        // example, return /admin/.test(Vue.$route.path);
        commit("members/ADD_TEAM", team, { root: true });

        dispatch("program/addTeamToProgramTeams", team, {
          root: true
        });

        dispatch(
          "snackBar",
          {
            duration: 10000,
            queue: false,
            message: "Team successfully created!",
            type: "is-success"
          },
          { root: true }
        );
        // TODO refactor to teamBuilder
        dispatch("challengeBuilder/emptyStagedMembers", null, { root: true });

        Vue.auth.fetch(); // refresh logged in members teams

        return response;
      }
    } catch (error) {
      dispatch(
        "snackBar",
        {
          duration: 10000,
          queue: false,
          message: error.response.data.error.message,
          type: "is-danger"
        },
        { root: true }
      );
      return false;
    }
  },

  updateTeam({ commit, dispatch, rootState }, payload) {
    const { teamId, formData } = payload;

    return Vue.axios
      .post(`teams/${teamId}`, formData)
      .then(response => {
        const updatedTeam = response.data.data;

        // update state so that, for instance, JoinChallengeWithTeam button is also updated
        // and anywhere else memberTeams and prgramTeams getters are used.
        dispatch("program/updateTeamInProgramTeams", updatedTeam, {
          root: true
        });
        dispatch("members/updateTeamInMemberTeams", updatedTeam, {
          root: true
        });
        dispatch("members/updateTeamInTeamsMemberIsAdmin", updatedTeam, {
          root: true
        });
        if (
          Vue._.get(rootState, "program.featuredChallenge.between", false) ===
          "groups"
        ) {
          commit(
            "program/SET_LOADED_STATUS",
            { key: "currentFeaturedChallengeLoaded", value: false },
            { root: true }
          );
        }

        dispatch(
          "pages/setPageLoaded",
          { key: "MyDashboard", value: false },
          { root: true }
        );
        dispatch(
          "pages/setPageLoaded",
          { key: "Challenges", value: false },
          { root: true }
        );
        // Challenge leaderboard displays the team name and needs to be updated when the team is updated
        // opting to reload the entire Challenge page because team may also need to be updated in
        // challenge and challenge-discussion which are both stored in state by challenge-id
        dispatch({ type: "pages/reloadChallengePages" }, { root: true });

        dispatch(
          "snackBar",
          {
            duration: 10000,
            queue: false,
            message: "Team successfully updated!",
            type: "is-success"
          },
          { root: true }
        );

        Vue.auth.fetch(); // refresh logged in members teams

        return response;
      })
      .catch(error => {
        let message = "Hmm, there was an error. ";

        Vue._.forOwn(error.response.data.error.fields, field => {
          message += field[0];
        });

        dispatch(
          "snackBar",
          {
            duration: 10000,
            queue: false,
            message: error.response.data.error.message || message,
            type: "is-danger"
          },
          { root: true }
        );

        if (error.status === 403) {
          setTimeout(() => {
            Vue.router.push({ name: "Teams" });
          }, 2000);
        }

        return false;
      });
  },

  addMembersToTeam({ commit, dispatch }, payload) {
    let { team, memberIds } = payload;

    let formData = new FormData();
    memberIds.map((memberId, index) => {
      formData.append(`memberIds[${index}]`, memberId);
    });

    commit(types.SET_LOADING_STATUS, {
      key: "memberJoiningTeam",
      value: true
    });

    return Vue.axios
      .post(`teams/${team.id}/add-member`, formData)
      .then(response => {
        if (response && response.data.success) {
          const team = response.data.data;

          if (memberIds.find(id => id === Vue.auth.user().id)) {
            commit("members/ADD_TEAM", team, { root: true });
            dispatch(
              "snackBar",
              {
                message: `Successfully joined team ${team.name}!`
              },
              { root: true }
            );
          } else {
            dispatch(
              "snackBar",
              {
                message: `Successfully added members to team, ${team.name}!`
              },
              { root: true }
            );
          }

          commit(types.SET_LOADING_STATUS, {
            key: "memberJoiningTeam",
            value: false
          });

          Vue.auth.fetch(); // refresh logged in members teams

          return team;
        }
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            duration: 10000,
            queue: false,
            message: error.response.data.error.message,
            type: "is-danger"
          },
          { root: true }
        );

        return false;
      });
  },

  removeMembersFromTeam({ dispatch }, payload) {
    let { teamId, memberIds } = payload;

    let formData = new FormData();
    memberIds.map((memberId, index) => {
      formData.append(`memberIds[${index}]`, memberId);
    });

    return Vue.axios
      .post(`teams/${teamId}/remove-member`, formData)
      .then(response => {
        Vue.auth.fetch(); // refresh logged in members teams
        return response;
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            duration: 10000,
            queue: false,
            message: error.response.data.error.message,
            type: "is-danger"
          },
          { root: true }
        );

        return false;
      });
  },

  promoteTeamLeader({ dispatch }, payload) {
    const { memberId, teamId, showSnackbar = true } = payload;
    return Vue.axios
      .put(`teams/${teamId}/promote-member`, { memberId })
      .then(response => {
        if (response && response.data.success) {
          if (showSnackbar) {
            dispatch(
              "snackBar",
              {
                duration: 10000,
                queue: false,
                message: "Member has been promoted to team leader.",
                type: "is-success"
              },
              { root: true }
            );
          }

          Vue.auth.fetch(); // refresh logged in members teams

          return response;
        }
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            message: error.response.data.error.message,
            type: "is-danger",
            queue: false,
            duration: 10000
          },
          { root: true }
        );

        if (error.status === 403) {
          setTimeout(() => {
            Vue.router.push({ name: "Teams" });
          }, 2000);
        }

        return false;
      });
  },

  demoteTeamLeader({ dispatch }, payload) {
    const { memberId, teamId } = payload;
    return Vue.axios
      .put(`teams/${teamId}/demote-member`, { memberId })
      .then(response => {
        if (response && response.data.success) {
          dispatch(
            "snackBar",
            {
              duration: 10000,
              queue: false,
              message: "Member has been demoted from team leader.",
              type: "is-success"
            },
            { root: true }
          );

          Vue.auth.fetch(); // refresh logged in members teams

          return response;
        }
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            message: error.response.data.error.message,
            type: "is-danger",
            queue: false,
            duration: 10000
          },
          { root: true }
        );

        if (error.status === 403) {
          setTimeout(() => {
            Vue.router.push({ name: "Teams" });
          }, 2000);
        }

        return false;
      });
  },

  deleteTeam({ dispatch }, teamId) {
    return Vue.axios
      .delete(`teams/${teamId}`)
      .then(response => {
        if (response && response.data.success) {
          dispatch("program/removeTeamFromProgramTeams", teamId, {
            root: true
          });

          dispatch(
            "snackBar",
            {
              duration: 10000,
              queue: false,
              message: "Team successfully deleted!",
              type: "is-success"
            },
            { root: true }
          );
        }
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            message: error.response.data.error.message,
            type: "is-danger",
            queue: false,
            duration: 10000
          },
          { root: true }
        );
        if (error.status === 403) {
          setTimeout(() => {
            Vue.router.push({ name: "Teams" });
          }, 2000);
        }
      });
  },

  deleteAllTeams({ dispatch }) {
    return Vue.axios
      .delete(`teams`)
      .then(response => {
        if (response && response.data.success) {
          response.data.data.forEach(teamId => {
            dispatch("program/removeTeamFromProgramTeams", teamId, {
              root: true
            });
          });

          dispatch(
            "snackBar",
            {
              duration: 10000,
              queue: false,
              message: "Teams successfully deleted!",
              type: "is-success"
            },
            { root: true }
          );

          Vue.auth.fetch(); // refresh logged in members teams
        }
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            message: error.response.data.error.message,
            type: "is-danger",
            queue: false,
            duration: 10000
          },
          { root: true }
        );
      });
  },

  fetchTeamLeaderboard(_, payload) {
    let { teamId, perPage = 15, page = 1 } = payload;
    return Vue.axios
      .get(`teams/${teamId}/leaderboard`, {
        params: { perPage, page }
      })
      .then(response => response.data);
  },

  fetchTeamMembers(_, payload) {
    let { teamId, perPage = 15, orderBy = "username" } = payload;
    return Vue.axios.get(`teams/${teamId}/members`, {
      params: { perPage, orderBy }
    });
  },

  fetchTeamDiscussionSubscriptions(_, topicId) {
    return Vue.axios
      .get(`topics/${topicId}/subscriptions`)
      .then(response => response.data.data.memberIds);
  },

  teamDiscussionSubscribeAction({ dispatch }, payload) {
    const { topicId, subscribe } = payload;

    return Vue.axios
      .post(`topics/${topicId}/subscription`, {
        subscribe
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            message: error.response.data.error.message,
            type: "is-danger",
            queue: false,
            duration: 10000
          },
          { root: true }
        );
      });
  },

  deleteTeamDiscussionPhoto({ dispatch }, payload) {
    const { itemId } = payload;

    return Vue.axios
      .post(`discussions/${itemId}/destroy-image`)
      .catch(error => {
        dispatch(
          "snackBar",
          {
            message: error.response.data.error.message,
            type: "is-danger",
            queue: false,
            duration: 10000
          },
          { root: true }
        );
      });
  },

  deleteTeamDiscussionPost({ dispatch }, discussionPostId) {
    return Vue.axios
      .delete(`discussions/${discussionPostId}`)
      .then(response => {
        dispatch(
          "snackBar",
          {
            type: "is-success",
            message: "The discussion post has been deleted."
          },
          { root: true }
        );

        return response;
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            message: error.response.data.error.message,
            type: "is-danger",
            queue: false,
            duration: 10000
          },
          { root: true }
        );
      });
  },

  storeTeamDiscussion({ dispatch }, payload) {
    const { formData } = payload;

    return Vue.axios.post(`discussions`, formData).catch(error => {
      dispatch(
        "snackBar",
        {
          message: error.response.data.error.message,
          type: "is-danger",
          queue: false,
          duration: 10000
        },
        { root: true }
      );
    });
  },

  async updateTeamDiscussion({ dispatch }, payload) {
    const { itemId, formData } = payload;

    return Vue.axios.post(`discussions/${itemId}`, formData).catch(error => {
      dispatch(
        "snackBar",
        {
          message: error.response.data.error.message,
          type: "is-danger",
          queue: false,
          duration: 10000
        },
        { root: true }
      );
    });
  },

  async fetchTeamDiscussion({ commit }, payload) {
    let { teamId, photosOnly = false, page = null } = payload;
    commit(types.SET_LOADED_STATUS, {
      key: "teamDiscussionLoaded",
      value: false
    });

    const response = await Vue.axios.get(`teams/${teamId}/discussion`, {
      params: { photosOnly: photosOnly ? 1 : 0, page }
    });

    commit(types.SET_TEAM_DISCUSSION, {
      key: "teamDiscussion",
      value: response.data
    });

    commit(types.SET_LOADED_STATUS, {
      key: "teamDiscussionLoaded",
      value: true
    });

    return response;
  },

  clearTeamDiscussion({ commit }) {
    commit(types.SET_TEAM_DISCUSSION, {
      key: "teamDiscussion",
      value: {}
    });
    commit(types.SET_LOADED_STATUS, {
      key: "teamDiscussionLoaded",
      value: false
    });
  },

  fetchTeamAggregate(_, payload) {
    let { teamId, todayDate = null } = payload;
    const params = todayDate ? { todayDate } : null;
    return Vue.axios
      .get(`teams/${teamId}/aggregate-data`, { params })
      .then(response => {
        return response.data.data;
      });
  },

  fetchTeamStepsData(_, payload) {
    let { teamId } = payload;

    return Vue.axios
      .get(`teams/${teamId}/step-data`, { params: payload })
      .then(response => {
        return response.data.data;
      });
  },

  fetchTeamMembersStepsData(_, payload) {
    let { teamId, perPage = 15 } = payload;

    return Vue.axios
      .get(`teams/${teamId}/members-step-data`, {
        params: { perPage, ...payload }
      })
      .then(response => {
        return response.data;
      });
  },

  updateAddCreatorToTeam({ commit }, bool) {
    commit(types.SET_ADD_CREATOR_TO_TEAM, bool);
  },

  updateTeamMembersInviteMode({ commit }, mode) {
    commit(types.SET_TEAM_MEMBERS_INVITE_MODE, mode);
  }
};

export default actions;
